//對state操作的方法
import {
 // INSU_REQUEST_MUTATION,
 // INSU_MODAL_MUTATION,
  SELECT_INSU_MUTATION,
 // RESET_SELECTED_MUTATION,
 // SET_QUERY_MUTATION,
  //RESET_QUERY_MUTATION,
 // SET_PRODUCTS_MUTATION,
 // RESET_PRODUCTS_MUTATION,
} from './constants';
/*
// request
const insuReqMutation = (state, bool) => {
  state.loading = bool;
};

// set query
const setQuery = (state, { key, tips, ...model }) => {
  state.queryInfo = { model, tips };
};

const resetQuery = (state) => {
  state.queryInfo = { model: null, tips: null };
};

// modal
const modal = (state, payload) => {
  state.modal = payload;
};
*/
// selected Id
const selectInsu = (state, payload) => {
  state.selectedInsus = [...payload];
};
/*
const resetSelected = (state) => {
  state.selectedInsus = [];
};

// set product
const setProducts = (state, payload) => {
  const stateKeys = Object.keys(payload);
  const sortedProd = stateKeys.reduce((acc, currKey) => {
    const products = payload[currKey].map(prod => ({
      ...prod,
      prodType: currKey
    }));
    return {
      ...acc,
      [currKey]: products.sort((a, b) => a.premiums - b.premiums)
    };
  }, {});
  state.products = sortedProd;
};

const resetProducts = (state) => {
  state.products = null;
};
*/
export default {
 // [INSU_REQUEST_MUTATION]: insuReqMutation,
 // [SET_QUERY_MUTATION]: setQuery,
 // [RESET_QUERY_MUTATION]: resetQuery,
 // [SET_PRODUCTS_MUTATION]: setProducts,
 // [RESET_PRODUCTS_MUTATION]: resetProducts,
 // [INSU_MODAL_MUTATION]: modal,
  [SELECT_INSU_MUTATION]: selectInsu,
 // [RESET_SELECTED_MUTATION]: resetSelected,
};